import { render } from "./TvmStartUpButtons.vue?vue&type=template&id=91ef4d8e&scoped=true"
import script from "./TvmStartUpButtons.js?vue&type=script&lang=js&external"
export * from "./TvmStartUpButtons.js?vue&type=script&lang=js&external"

import "./TvmStartUpButtons.vue?vue&type=style&index=0&id=91ef4d8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91ef4d8e"]])

export default __exports__